import { useState } from 'react';

export function useUnlockIcc({
  failedTransactionsListDetailsIpb,
  actionIccUnlockingAction,
  onSuccessClose,
}) {
  const [isUnlockIccDialogOpen, setIsUnlockIccDialogOpen] = useState(false);
  const [unlockIccMessage, setUnlockIccMessage] = useState('');
  const [isSuccessDialogOpen, setIsSuccessDialogOpen] = useState(false);

  const iccToUnlock = Array.isArray(failedTransactionsListDetailsIpb?.response?.details)
    ? failedTransactionsListDetailsIpb.response.details[0]?.icc_number
    : undefined;

  const handleUnlockIcc = async (reason) => {
    if (iccToUnlock) {
      try {
        const response = await actionIccUnlockingAction({
          iccid: iccToUnlock,
          reason,
        });
        if (response?.status === 200) {
          setIsUnlockIccDialogOpen(false);
          setUnlockIccMessage('Desbloqueo de ICC exitoso');
          setIsSuccessDialogOpen(true);
        } else {
          setUnlockIccMessage(
            response?.data?.message || 'El estatus de esta linea ya se encuentra en IDLE.',
          );
        }
      } catch (error) {
        setUnlockIccMessage('Error de red al desbloquear ICC.');
      }
    } else {
      setUnlockIccMessage('No se encontró ICC Number.');
    }
  };

  const handleOpenUnlockIccDialog = () => {
    setIsUnlockIccDialogOpen(true);
    setUnlockIccMessage('');
  };
  const handleCloseUnlockIccDialog = () => setIsUnlockIccDialogOpen(false);
  const handleCloseSuccessDialog = () => {
    setIsSuccessDialogOpen(false);
    if (typeof onSuccessClose === 'function') {
      onSuccessClose(); // Llama al callback para refrescar la tabla
    }
  };

  return {
    isUnlockIccDialogOpen,
    unlockIccMessage,
    isSuccessDialogOpen,
    handleUnlockIcc,
    handleOpenUnlockIccDialog,
    handleCloseUnlockIccDialog,
    handleCloseSuccessDialog,
    iccToUnlock,
  };
}
